export const SITE = {
  companyName: "Réparation de pavé uni Rive-Sud",
  companyNameEn: "Réparation de pavé uni Rive-Sud",
  phone: "4507005297",
  phoneDisplay: "450-700-5297",
  email: "groupestructera@gmail.com",
  address: "20 Rue Mansart, Saint-Jean-sur-Richelieu, QC J2W 1W6",
  googleMapsLink:
    "https://www.google.com/maps/search/?api=1&query=20+Rue+Mansart+Saint-Jean-sur-Richelieu+QC+J2W+1W6",
  baseUrl: "https://reparation-pave-uni-rive-sud.com",
};

export const IMAGES = {
  heroInstallation:
    "https://images.unsplash.com/photo-1745761264735-bb67c685b82b?crop=entropy&cs=srgb&auto=format&fit=crop&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBkcml2ZXdheSUyMHBhdmluZyUyMHN0b25lJTIwbW9kZXJuJTIwaG91c2V8ZW58MHx8fHwxNzcxMDI2NTg4fDA&ixlib=rb-4.1.0",
  heroRepair:
    "https://images.unsplash.com/photo-1561319090-aa0389390471?crop=entropy&cs=srgb&auto=format&fit=crop&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBkcml2ZXdheSUyMHBhdmluZyUyMHN0b25lJTIwbW9kZXJuJTIwaG91c2V8ZW58MHx8fHwxNzcxMDI2NTg4fDA&ixlib=rb-4.1.0",
  textureStone:
    "https://images.unsplash.com/photo-1614213827226-0b6ecc61a287?crop=entropy&cs=srgb&auto=format&fit=crop&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxzdG9uZSUyMHBhdGlvJTIwdGV4dHVyZSUyMGhpZ2glMjBxdWFsaXR5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzEwMjY2MTN8MA&ixlib=rb-4.1.0",
  workerAction:
    "https://images.unsplash.com/photo-1680699231780-ed1966cb70bd?crop=entropy&cs=srgb&auto=format&fit=crop&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZyUyMHdvcmtlciUyMGluc3RhbGxpbmclMjBwYXZlcnMlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzcxMDI2NTkzfDA&ixlib=rb-4.1.0",
  textureOldStone:
    "https://images.unsplash.com/photo-1661113258396-8860ef8d14af?crop=entropy&cs=srgb&auto=format&fit=crop&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxzdG9uZSUyMHBhdGlvJTIwdGV4dHVyZSUyMGhpZ2glMjBxdWFsaXR5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzEwMjY2MTN8MA&ixlib=rb-4.1.0",
};

export const SERVICES = {
  repair: {
    key: "repair",
    nameFr: "Réparation de pavé uni",
    nameEn: "Paver repair",
    slugFr: "reparation-pave-uni",
    slugEn: "paver-repair",
    shortFr: "Réparation",
    shortEn: "Repair",
    taglineFr: "Stabiliser, corriger, prolonger la durée de vie",
    taglineEn: "Stabilize, correct, and extend lifespan",
    descriptionFr:
      "Remise à niveau, remplacement ciblé et joints durables pour un pavé solide et sécuritaire.",
    descriptionEn:
      "Re-leveling, targeted replacements, and durable joints for a stable, safe surface.",
    focusFr:
      "remettre à niveau les pavés affaissés, corriger la base et refaire les joints",
    focusEn:
      "re-level sunken pavers, correct the base, and restore joints",
    ctaFr: "Demander une réparation",
    ctaEn: "Request repair",
    heroImage: IMAGES.heroRepair,
  },
  installation: {
    key: "installation",
    nameFr: "Installation de pavé uni",
    nameEn: "Paver installation",
    slugFr: "installation-pave-uni",
    slugEn: "paver-installation",
    shortFr: "Installation",
    shortEn: "Installation",
    taglineFr: "Un pavé neuf, stable et élégant",
    taglineEn: "A new, stable, elegant surface",
    descriptionFr:
      "Conception complète, base compactée et pose précise pour des entrées et terrasses haut de gamme.",
    descriptionEn:
      "Full design, compacted base, and precise laying for premium driveways and patios.",
    focusFr: "préparer une base durable, poser avec précision et assurer le drainage",
    focusEn: "prepare a durable base, lay precisely, and secure drainage",
    ctaFr: "Planifier une installation",
    ctaEn: "Plan an installation",
    heroImage: IMAGES.heroInstallation,
  },
  cleaning: {
    key: "cleaning",
    nameFr: "Nettoyage de pavé",
    nameEn: "Paver cleaning",
    slugFr: "nettoyage-pave-uni",
    slugEn: "paver-cleaning",
    taglineFr: "Nettoyage profond et préparation",
    taglineEn: "Deep cleaning and preparation",
    descriptionFr:
      "Élimination des taches, mousse et résidus pour révéler la couleur naturelle du pavé.",
    descriptionEn:
      "Removal of stains, moss, and residue to reveal the natural paver color.",
  },
  sealing: {
    key: "sealing",
    nameFr: "Scellant protecteur",
    nameEn: "Protective sealing",
    slugFr: "scellant-protecteur-pave-uni",
    slugEn: "paver-sealing",
    taglineFr: "Protection durable et fini satiné",
    taglineEn: "Long-term protection and satin finish",
    descriptionFr:
      "Application de scellant pour protéger contre l'eau, le sel et les UV.",
    descriptionEn:
      "Sealer application to protect against water, salt, and UV exposure.",
  },
};

export const SPECIAL_SERVICES = {
  cleaning: {
    key: "cleaning",
    slugFr: "nettoyage-pave-uni",
    slugEn: "paver-cleaning",
    fr: {
      metaTitle: "Nettoyage de pavé uni Rive-Sud | Soumission gratuite",
      metaDescription:
        "Nettoyage professionnel de pavé uni sur la Rive-Sud. Élimination des taches, mousse et résidus pour un pavé propre et durable.",
      h1: "Nettoyage de pavé uni sur la Rive-Sud – Lavage à pression professionnel",
      customHtml: `
<section data-testid="nettoyage-rive-sud-section">
  <header data-testid="nettoyage-rive-sud-header">
    <p style="letter-spacing:.25em; text-transform:uppercase; font-size:14px; margin:0 0 8px 0;" data-testid="nettoyage-rive-sud-label">Service spécialisé</p>
    <h1 data-testid="nettoyage-rive-sud-h1">Nettoyage de pavé uni sur la Rive-Sud – Lavage à pression professionnel</h1>
    <p data-testid="nettoyage-rive-sud-intro">
      Redonnez l'éclat d'origine à votre pavé uni grâce à un nettoyage professionnel adapté aux conditions de la Rive-Sud.
      Entre le gel-dégel, le sel de déglaçage, l'humidité et les saisons, le pavé uni accumule rapidement mousse, taches,
      résidus et saleté incrustée. Un <strong>lavage à pression contrôlée</strong> permet de raviver la couleur, d'améliorer la
      sécurité (surface moins glissante) et de préparer la surface pour un entretien durable.
    </p>
    <p data-testid="nettoyage-rive-sud-intro-2">
      Nous desservons la Rive-Sud et les environs, notamment <strong>Longueuil, Brossard, Saint-Hubert, Boucherville,
      Saint-Lambert, Chambly</strong> et <strong>Saint-Jean-sur-Richelieu</strong>.
    </p>
  </header>

  <hr style="margin:28px 0; opacity:.2;" data-testid="nettoyage-rive-sud-divider-1" />

  <h2 data-testid="nettoyage-rive-sud-why-title">Pourquoi nettoyer son pavé uni</h2>
  <p data-testid="nettoyage-rive-sud-why-text">
    Un pavé uni propre, ce n'est pas juste "beau". C'est aussi plus sécuritaire, plus durable et plus facile à entretenir.
    Quand la saleté s'accumule, elle retient l'humidité, favorise la mousse et accélère la dégradation des joints.
    Un nettoyage régulier protège votre investissement et garde vos surfaces stables et uniformes.
  </p>
  <ul data-testid="nettoyage-rive-sud-why-list">
    <li data-testid="nettoyage-rive-sud-why-item-safety"><strong>Sécurité :</strong> moins de mousse = moins de zones glissantes.</li>
    <li data-testid="nettoyage-rive-sud-why-item-durability"><strong>Durabilité :</strong> enlève les contaminants qui détériorent les joints et la surface.</li>
    <li data-testid="nettoyage-rive-sud-why-item-aesthetic"><strong>Esthétique :</strong> ravive la couleur et redonne un aspect propre.</li>
    <li data-testid="nettoyage-rive-sud-why-item-prevention"><strong>Prévention :</strong> limite les taches permanentes (huile, rouille, dépôts).</li>
  </ul>

  <h2 data-testid="nettoyage-rive-sud-problems-title">Problèmes fréquents sur la Rive-Sud</h2>
  <p data-testid="nettoyage-rive-sud-problems-text">
    Sur la Rive-Sud, plusieurs facteurs reviennent souvent : humidité, ombre, végétation, sel l'hiver et cycles gel-dégel.
    Résultat : les surfaces se tachent et les joints se fragilisent plus vite.
  </p>
  <h3 data-testid="nettoyage-rive-sud-problem-moss-title">Mousse et algues entre les joints</h3>
  <p data-testid="nettoyage-rive-sud-problem-moss-text">
    Elles apparaissent surtout dans les zones ombragées ou humides. En plus d'être inesthétiques, elles rendent la surface
    glissante et retiennent l'eau dans les joints.
  </p>
  <h3 data-testid="nettoyage-rive-sud-problem-dark-title">Pavé uni noirci ou terni</h3>
  <p data-testid="nettoyage-rive-sud-problem-dark-text">
    Poussière, pollution, résidus organiques et circulation : tout ça "colle" au pavé. Le bon nettoyage retire la pellicule
    et remet la couleur en valeur.
  </p>
  <h3 data-testid="nettoyage-rive-sud-problem-oil-title">Taches d'huile et de graisse</h3>
  <p data-testid="nettoyage-rive-sud-problem-oil-text">
    Très fréquent sur les entrées et stationnements. Un traitement ciblé avant ou pendant le lavage augmente fortement
    les chances d'élimination (ou d'atténuation nette).
  </p>
  <h3 data-testid="nettoyage-rive-sud-problem-sand-title">Joints vidés / sable polymère usé</h3>
  <p data-testid="nettoyage-rive-sud-problem-sand-text">
    Un lavage mal fait peut arracher le sable des joints. Un lavage professionnel utilise une pression adaptée et, au besoin,
    on recommande une remise en joints pour stabiliser l'ensemble.
  </p>

  <h2 data-testid="nettoyage-rive-sud-freeze-title">L'impact du gel-dégel au Québec</h2>
  <p data-testid="nettoyage-rive-sud-freeze-text">
    Le gel-dégel, c'est le boss final des surfaces extérieures. L'eau pénètre dans les joints, gèle, prend du volume, puis
    dégèle et recommence. Avec le temps, ça ouvre les joints, favorise la repousse de mousse et peut contribuer à des zones
    qui se déstabilisent. Un bon nettoyage + des joints bien remplis = une base plus stable et plus durable.
  </p>

  <h2 data-testid="nettoyage-rive-sud-method-title">Notre méthode professionnelle de lavage à pression</h2>
  <p data-testid="nettoyage-rive-sud-method-text">
    Notre approche vise un résultat propre <strong>sans abîmer les joints</strong>. On adapte la pression, l'angle et la méthode
    selon l'état du pavé, le type de surface et le niveau d'encrassement.
  </p>
  <ol data-testid="nettoyage-rive-sud-method-list">
    <li data-testid="nettoyage-rive-sud-method-item-1"><strong>Inspection rapide :</strong> état du pavé, joints, taches, zones sensibles.</li>
    <li data-testid="nettoyage-rive-sud-method-item-2"><strong>Pré-traitement ciblé :</strong> mousse / taches selon la situation.</li>
    <li data-testid="nettoyage-rive-sud-method-item-3"><strong>Lavage à pression contrôlée :</strong> nettoyage en profondeur sans "décaper" inutilement.</li>
    <li data-testid="nettoyage-rive-sud-method-item-4"><strong>Nettoyage des joints :</strong> retrait des résidus et rinçage propre.</li>
    <li data-testid="nettoyage-rive-sud-method-item-5"><strong>Rinçage uniforme :</strong> finition nette, sans traces.</li>
    <li data-testid="nettoyage-rive-sud-method-item-6"><strong>Recommandation post-service :</strong> sable polymère et/ou scellant si pertinent.</li>
  </ol>

  <h2 data-testid="nettoyage-rive-sud-sand-title">Nettoyage + sable polymère : la combinaison durable</h2>
  <p data-testid="nettoyage-rive-sud-sand-text">
    Après un lavage, surtout si les joints étaient déjà fragiles, il peut être judicieux de refaire les joints au
    <strong>sable polymère</strong>. Pourquoi ? Parce que c'est lui qui stabilise l'ensemble, limite la repousse de mousse
    et améliore la tenue dans le temps.
  </p>
  <ul data-testid="nettoyage-rive-sud-sand-list">
    <li data-testid="nettoyage-rive-sud-sand-item-1">Réduit la repousse de mousse et mauvaises herbes</li>
    <li data-testid="nettoyage-rive-sud-sand-item-2">Stabilise les pavés et diminue les mouvements</li>
    <li data-testid="nettoyage-rive-sud-sand-item-3">Améliore l'apparence (joints propres et uniformes)</li>
  </ul>

  <h2 data-testid="nettoyage-rive-sud-sealer-title">Application de scellant protecteur (option premium)</h2>
  <p data-testid="nettoyage-rive-sud-sealer-text">
    Un nettoyage complet est la meilleure préparation avant un <strong>scellant protecteur</strong>. Le scellant aide à protéger
    contre l'eau, le sel, les taches et les UV. Il ravive souvent la couleur et facilite l'entretien futur.
  </p>
  <p data-testid="nettoyage-rive-sud-sealer-tip">
    <strong>Astuce :</strong> le scellant n'est pas obligatoire, mais il peut prolonger l'aspect "comme neuf" et réduire l'entretien
    sur le long terme. (Voir aussi : <em>Scellant protecteur pour pavé uni</em>.)
  </p>

  <h2 data-testid="nettoyage-rive-sud-price-title">Prix nettoyage pavé uni sur la Rive-Sud</h2>
  <p data-testid="nettoyage-rive-sud-price-text">
    Le prix varie selon plusieurs facteurs. Une soumission rapide permet d'évaluer correctement, sans guess.
  </p>
  <ul data-testid="nettoyage-rive-sud-price-list">
    <li data-testid="nettoyage-rive-sud-price-item-1"><strong>Surface totale :</strong> entrée, terrasse, trottoir, stationnement</li>
    <li data-testid="nettoyage-rive-sud-price-item-2"><strong>Niveau d'encrassement :</strong> mousse, taches, noirceur</li>
    <li data-testid="nettoyage-rive-sud-price-item-3"><strong>Type de taches :</strong> huile, rouille, dépôts</li>
    <li data-testid="nettoyage-rive-sud-price-item-4"><strong>État des joints :</strong> besoin de sable polymère / rejointoiement</li>
    <li data-testid="nettoyage-rive-sud-price-item-5"><strong>Options :</strong> scellant protecteur</li>
  </ul>
  <p data-testid="nettoyage-rive-sud-price-text-2">
    Pour un prix exact, le plus simple est une <strong>soumission gratuite</strong> avec vos photos ou une courte évaluation sur place.
  </p>

  <h2 data-testid="nettoyage-rive-sud-cities-title">Villes desservies sur la Rive-Sud</h2>
  <p data-testid="nettoyage-rive-sud-cities-text">
    Nous couvrons le nettoyage de pavé uni sur la Rive-Sud, incluant :
  </p>
  <ul data-testid="nettoyage-rive-sud-cities-list">
    <li data-testid="nettoyage-rive-sud-city-longueuil">Longueuil</li>
    <li data-testid="nettoyage-rive-sud-city-brossard">Brossard</li>
    <li data-testid="nettoyage-rive-sud-city-saint-hubert">Saint-Hubert</li>
    <li data-testid="nettoyage-rive-sud-city-boucherville">Boucherville</li>
    <li data-testid="nettoyage-rive-sud-city-saint-lambert">Saint-Lambert</li>
    <li data-testid="nettoyage-rive-sud-city-chambly">Chambly</li>
    <li data-testid="nettoyage-rive-sud-city-saint-jean">Saint-Jean-sur-Richelieu</li>
    <li>La Prairie</li>
    <li>Candiac</li>
    <li>Saint-Bruno-de-Montarville</li>
  </ul>
  
  <h2 data-testid="nettoyage-rive-sud-choose-title">Pourquoi choisir notre équipe</h2>
  <ul data-testid="nettoyage-rive-sud-choose-list">
    <li data-testid="nettoyage-rive-sud-choose-item-1"><strong>Expertise locale :</strong> méthodes adaptées au climat et aux réalités de la Rive-Sud.</li>
    <li data-testid="nettoyage-rive-sud-choose-item-2"><strong>Pression maîtrisée :</strong> nettoyage efficace sans endommager inutilement les joints.</li>
    <li data-testid="nettoyage-rive-sud-choose-item-3"><strong>Résultat durable :</strong> conseils clairs sur sable polymère et scellant.</li>
    <li data-testid="nettoyage-rive-sud-choose-item-4"><strong>Soumission gratuite :</strong> estimation rapide et transparente.</li>
  </ul>

  <h2 data-testid="nettoyage-rive-sud-faq-title">FAQ – Nettoyage de pavé uni</h2>
  <h3 data-testid="nettoyage-rive-sud-faq-q1">À quelle fréquence nettoyer un pavé uni ?</h3>
  <p data-testid="nettoyage-rive-sud-faq-a1">En général, tous les 1 à 2 ans. Plus souvent si la zone est ombragée ou très humide.</p>

  <h3 data-testid="nettoyage-rive-sud-faq-q2">Le lavage à pression peut-il abîmer les joints ?</h3>
  <p data-testid="nettoyage-rive-sud-faq-a2">Oui si c'est fait trop fort ou au mauvais angle. Avec une pression contrôlée et la bonne technique, on nettoie sans tout arracher.</p>

  <h3 data-testid="nettoyage-rive-sud-faq-q3">Peut-on enlever les taches d'huile ?</h3>
  <p data-testid="nettoyage-rive-sud-faq-a3">Souvent oui, surtout avec un traitement adapté. Certaines taches anciennes peuvent nécessiter plus d'une intervention pour atténuation maximale.</p>

  <h3 data-testid="nettoyage-rive-sud-faq-q4">Dois-je remettre du sable polymère après nettoyage ?</h3>
  <p data-testid="nettoyage-rive-sud-faq-a4">Si les joints sont affaiblis ou vidés, c'est fortement recommandé pour stabiliser et limiter la repousse de mousse.</p>

  <h3 data-testid="nettoyage-rive-sud-faq-q5">Est-ce que le scellant est nécessaire ?</h3>
  <p data-testid="nettoyage-rive-sud-faq-a5">Non, mais il ajoute une protection contre l'eau, le sel et les taches, et facilite l'entretien.</p>

  <hr style="margin:28px 0; opacity:.2;" data-testid="nettoyage-rive-sud-divider-2" />

  <div style="padding:16px; border:1px solid rgba(0,0,0,.12); border-radius:12px;" data-testid="nettoyage-rive-sud-cta-block">
    <h2 style="margin-top:0;" data-testid="nettoyage-rive-sud-cta-title">Soumission gratuite – Nettoyage pavé uni Rive-Sud</h2>
    <p style="margin-bottom:12px;" data-testid="nettoyage-rive-sud-cta-text">
      Vous voulez un prix rapide ? Envoyez-nous quelques photos et votre ville, et on vous revient rapidement.
    </p>
    <ul style="margin:0;" data-testid="nettoyage-rive-sud-cta-list">
      <li data-testid="nettoyage-rive-sud-cta-item-1"><strong>Soumission gratuite</strong></li>
      <li data-testid="nettoyage-rive-sud-cta-item-2"><strong>Intervention rapide sur la Rive-Sud</strong></li>
      <li data-testid="nettoyage-rive-sud-cta-item-3"><strong>Option sable polymère + scellant</strong></li>
    </ul>
  </div>
</section>
      `,
      ctaText: "Réponse rapide sous 24 h sur la Rive-Sud.",
    },
    en: {
      metaTitle: "Paver cleaning South Shore | Free estimate",
      metaDescription:
        "Professional paver cleaning on Montréal's South Shore. Remove stains, moss, salt, and residue for a clean, durable surface.",
      h1: "Paver cleaning on Montréal's South Shore",
      intro:
        "Restore the original look of your pavers with professional cleaning designed for South Shore conditions. We remove stains, moss, salt, and buildup for a clean, durable, and safe surface.",
      sections: [
        {
          title: "Why clean your pavers",
          text: "Dirt buildup, fading color, slippery surfaces, and premature wear are common without maintenance. Cleaning preserves curb appeal and improves safety.",
        },
        {
          title: "Our professional method",
          text: "Deep cleaning, controlled pressure, tailored products, and joint protection to maintain the integrity of your pavers.",
        },
        {
          title: "Expected results",
          text: "Revived color, a clean surface, improved durability, and the ideal prep before sealing.",
        },
      ],
      seoLine:
        "We provide paver cleaning across the South Shore, including Longueuil, Brossard, Saint-Hubert, Saint-Lambert, Boucherville, and Saint-Jean-sur-Richelieu.",
      ctaText: "Fast response within 24 hours across the South Shore.",
    },
  },
  sealing: {
    key: "sealing",
    slugFr: "scellant-protecteur-pave-uni",
    slugEn: "paver-sealing",
    fr: {
      metaTitle: "Scellant protecteur pavé uni Rive-Sud | Soumission gratuite",
      metaDescription:
        "Application de scellant pour pavé uni sur la Rive-Sud. Protection contre l'eau, le sel, les taches et les UV.",
      h1: "Application de scellant pour pavé uni sur la Rive-Sud",
      intro:
        "Protégez votre pavé uni contre l'eau, le sel, les taches et les UV grâce à un scellant professionnel conçu pour prolonger sa durée de vie et conserver son apparence.",
      sections: [
        {
          title: "Pourquoi appliquer un scellant",
          text: "Protection contre l'usure, prévention des taches, maintien de la couleur et réduction de l'entretien.",
        },
        {
          title: "Notre procédé d'application",
          text: "Préparation complète, séchage adéquat, scellant de qualité professionnelle et finition uniforme.",
        },
        {
          title: "Durabilité et entretien",
          text: "Protection longue durée adaptée au climat gel-dégel de la Rive-Sud.",
        },
      ],
      seoLine:
        "Nous appliquons des scellants pavé uni Rive-Sud pour la protection pavé uni à Longueuil, Brossard, Saint-Hubert, Saint-Lambert, Boucherville et Saint-Jean-sur-Richelieu.",
      ctaText: "Service rapide et estimation claire.",
    },
    en: {
      metaTitle: "Paver sealing South Shore | Free estimate",
      metaDescription:
        "Professional paver sealing on Montréal's South Shore. Protect against water, salt, stains, and UV exposure.",
      h1: "Paver sealing on Montréal's South Shore",
      intro:
        "Protect your pavers from water, salt, stains, and UV exposure with a professional sealer designed to extend lifespan and preserve appearance.",
      sections: [
        {
          title: "Why apply a sealer",
          text: "Protection against wear, stain prevention, color preservation, and reduced maintenance needs.",
        },
        {
          title: "Our application process",
          text: "Complete preparation, proper drying time, professional-grade sealer, and an even finish.",
        },
        {
          title: "Durability and maintenance",
          text: "Long-lasting protection suited to the South Shore's freeze-thaw climate.",
        },
      ],
      seoLine:
        "We provide paver sealing on the South Shore, including protection for pavers in Longueuil, Brossard, Saint-Hubert, Saint-Lambert, Boucherville, and Saint-Jean-sur-Richelieu.",
      ctaText: "Fast service with a clear, detailed estimate.",
    },
  },
};


export const CITY_DATA = [
  {
    slug: "longueuil",
    nameFr: "Longueuil",
    nameEn: "Longueuil",
    landmarkFr: "le Vieux-Longueuil et ses rues patrimoniales",
    landmarkEn: "Old Longueuil and its heritage streets",
    nearbyFr: "le parc Michel-Chartrand",
    nearbyEn: "Michel-Chartrand Park",
    localNoteFr: "près de la rue Saint-Charles",
    localNoteEn: "near Saint-Charles Street",
    areasFr: ["Vieux-Longueuil", "Saint-Charles", "Greenfield Park", "Laflèche", "Cité-des-Jeunes"],
    areasEn: ["Old Longueuil", "Saint-Charles", "Greenfield Park", "Laflèche", "Cité-des-Jeunes"],
    intro: "À Longueuil, les rues patrimoniales du Vieux-Longueuil et les quartiers résidentiels établis comme Saint-Charles subissent les effets cumulatifs du gel-dégel sur des fondations vieillissantes. La circulation dense sur les artères principales accentue les vibrations qui déstabilisent progressivement les pavés. Notre service de réparation redonne une surface stable et sécuritaire adaptée aux réalités du terrain longueuillois.",
    problemLocal: "Les entrées résidentielles autour du Vieux-Longueuil présentent fréquemment des affaissements localisés causés par des bases granulaires insuffisantes installées dans les années 70-80. Le drainage déficient vers les fondations est un problème récurrent dans les secteurs Saint-Charles et Greenfield Park, où les pentes mal orientées envoient l'eau de fonte vers les maisons plutôt que vers la rue.",
  },
  {
    slug: "brossard",
    nameFr: "Brossard",
    nameEn: "Brossard",
    landmarkFr: "le Quartier DIX30",
    landmarkEn: "the DIX30 District",
    nearbyFr: "le boulevard Taschereau",
    nearbyEn: "Taschereau Boulevard",
    localNoteFr: "autour du Quartier DIX30",
    localNoteEn: "around the DIX30 district",
    areasFr: ["Quartier DIX30", "Secteur R", "Secteur S", "Secteur C", "Boulevard Taschereau"],
    areasEn: ["DIX30 District", "Sector R", "Sector S", "Sector C", "Taschereau Boulevard"],
    intro: "À Brossard, les grandes entrées résidentielles des secteurs R, S et C ont été majoritairement construites dans les années 80-90 avec des standards de base qui ne résistent plus aux hivers québécois actuels. La proximité du boulevard Taschereau et la densité du trafic local créent des vibrations constantes qui accélèrent le déplacement des pavés. Un entretien ciblé permet d'éviter une détérioration complète coûteuse.",
    problemLocal: "Dans les secteurs résidentiels de Brossard, les pavés souffrent principalement de l'accumulation de sel de déglaçage en hiver, qui érode les joints et fragilise la base. Les entrées larges typiques de Brossard accumulent l'eau en surface lors des dégels rapides, créant des zones d'affaissement au centre et aux bordures qui s'élargissent d'année en année si elles ne sont pas traitées.",
  },
  {
    slug: "chambly",
    nameFr: "Chambly",
    nameEn: "Chambly",
    landmarkFr: "le Fort Chambly",
    landmarkEn: "Fort Chambly",
    nearbyFr: "le bassin de Chambly",
    nearbyEn: "the Chambly Basin",
    localNoteFr: "autour du Fort Chambly",
    localNoteEn: "around Fort Chambly",
    areasFr: ["Vieux-Chambly", "Bassin de Chambly", "Parc des Ateliers", "Hertel", "Carignan"],
    areasEn: ["Old Chambly", "Chambly Basin", "Parc des Ateliers", "Hertel", "Carignan"],
    intro: "À Chambly, la proximité du bassin et du Richelieu crée une humidité ambiante élevée qui pénètre les joints et accélère les cycles de gel-dégel sous les pavés. Les propriétés du Vieux-Chambly, avec leurs aménagements d'époque, présentent des problèmes de base particulièrement complexes à corriger. Notre équipe connaît les spécificités du terrain chamblyois et intervient avec les méthodes adaptées.",
    problemLocal: "Les entrées situées près du bassin de Chambly souffrent d'un taux d'humidité du sol plus élevé que la moyenne, ce qui fragilise les couches granulaires sous les pavés. Le secteur Hertel et les rues adjacentes au Vieux-Chambly présentent régulièrement des bordures ouvertes et des pavés soulevés par les racines des arbres matures plantés il y a plusieurs décennies.",
  },
  {
    slug: "saint-hubert",
    nameFr: "Saint-Hubert",
    nameEn: "Saint-Hubert",
    landmarkFr: "le Parc de la Cité",
    landmarkEn: "Parc de la Cité",
    nearbyFr: "le secteur Montarville",
    nearbyEn: "the Montarville sector",
    localNoteFr: "près du Parc de la Cité",
    localNoteEn: "near Parc de la Cité",
    areasFr: ["Vieux-Saint-Hubert", "Parc de la Cité", "Montarville", "Secteur Kimber", "Marois"],
    areasEn: ["Old Saint-Hubert", "Parc de la Cité", "Montarville", "Kimber sector", "Marois"],
    intro: "À Saint-Hubert, les quartiers résidentiels établis autour du Parc de la Cité et du secteur Montarville cumulent plusieurs décennies d'usure sur leurs aménagements en pavé uni. Les sols argileux caractéristiques de Saint-Hubert gonflent et se contractent selon les saisons, déstabilisant progressivement les bases granulaires. Une correction en profondeur de la fondation est souvent nécessaire pour obtenir un résultat durable.",
    problemLocal: "Le secteur Kimber et les rues résidentielles autour du Parc de la Cité présentent fréquemment des pavés affaissés en zones isolées, symptôme direct du gonflement argileux du sol. Dans le secteur Montarville, les entrées construites sans membrane géotextile montrent des signes de migration du sol sous la base granulaire, créant des irrégularités de surface progressives difficiles à ignorer.",
  },
  {
    slug: "saint-lambert",
    nameFr: "Saint-Lambert",
    nameEn: "Saint-Lambert",
    landmarkFr: "le Vieux-Saint-Lambert",
    landmarkEn: "Old Saint-Lambert",
    nearbyFr: "la promenade Riverside",
    nearbyEn: "Riverside Drive",
    localNoteFr: "près du Vieux-Saint-Lambert",
    localNoteEn: "near Old Saint-Lambert",
    areasFr: ["Vieux-Saint-Lambert", "Riverside", "Préville", "Parc Houde", "Saint-Lambert-Est"],
    areasEn: ["Old Saint-Lambert", "Riverside", "Préville", "Houde Park area", "East Saint-Lambert"],
    intro: "À Saint-Lambert, les propriétés riveraines et les rues patrimoniales du Vieux-Saint-Lambert allient cachet architectural et défis d'entretien importants pour le pavé uni. La nappe phréatique élevée près de la promenade Riverside et du fleuve contribue à l'instabilité des bases, surtout lors des printemps pluvieux. Notre expertise locale permet d'intervenir avec les techniques adaptées aux contraintes spécifiques de Saint-Lambert.",
    problemLocal: "Les entrées du secteur Riverside et du Vieux-Saint-Lambert présentent des problèmes de drainage complexes liés à la proximité du Saint-Laurent et à la topographie légèrement inclinée des terrains. Les pavés des rues patrimoniales souffrent d'un double problème : des fondations vieillissantes d'une part, et des arbres matures dont les racines soulèvent progressivement les blocs d'autre part.",
  },
  {
    slug: "boucherville",
    nameFr: "Boucherville",
    nameEn: "Boucherville",
    landmarkFr: "le Vieux-Boucherville",
    landmarkEn: "Old Boucherville",
    nearbyFr: "le parc national des Îles-de-Boucherville",
    nearbyEn: "Îles-de-Boucherville National Park",
    localNoteFr: "près du fleuve et du Vieux-Boucherville",
    localNoteEn: "near the river and Old Boucherville",
    areasFr: ["Vieux-Boucherville", "La Seigneurie", "Harmonie", "Domaine", "Les Îles"],
    areasEn: ["Old Boucherville", "La Seigneurie", "Harmonie", "Domaine", "Les Îles"],
    intro: "À Boucherville, la présence du fleuve Saint-Laurent et des îles crée un microclimat humide qui accélère la dégradation des joints et favorise les cycles de gel-dégel intenses sous les pavés. Les secteurs résidentiels comme La Seigneurie et Harmonie combinent de grandes propriétés avec des aménagements ambitieux qui demandent un entretien régulier et rigoureux. Notre équipe intervient avec des solutions durables adaptées au terrain bouchervillois.",
    problemLocal: "Les propriétés des secteurs La Seigneurie et Domaine à Boucherville présentent régulièrement des affaissements aux jonctions entre l'entrée et le trottoir municipal, là où les deux bases se rejoignent différemment. La proximité du fleuve génère un taux d'humidité persistant dans le sol qui fragilise les couches granulaires et favorise l'apparition de zones molles sous les pavés, surtout après un hiver rigoureux.",
  },
  {
    slug: "saint-jean-sur-richelieu",
    nameFr: "Saint-Jean-sur-Richelieu",
    nameEn: "Saint-Jean-sur-Richelieu",
    landmarkFr: "le Vieux-Saint-Jean",
    landmarkEn: "Old Saint-Jean",
    nearbyFr: "le canal de Chambly",
    nearbyEn: "the Chambly Canal",
    localNoteFr: "près du canal de Chambly",
    localNoteEn: "near the Chambly Canal",
    areasFr: ["Vieux-Saint-Jean", "Iberville", "Saint-Luc", "Saint-Athanase", "L'Acadie"],
    areasEn: ["Old Saint-Jean", "Iberville", "Saint-Luc", "Saint-Athanase", "L'Acadie"],
    intro: "À Saint-Jean-sur-Richelieu, la rivière Richelieu et le canal de Chambly maintiennent un niveau d'humidité du sol élevé qui accentue les effets du gel-dégel sur les fondations des entrées en pavé uni. Les quartiers Iberville et Saint-Luc, avec leurs constructions des années 70-90, arrivent à un stade critique où la réparation préventive est bien plus économique que la reconstruction complète. Notre équipe dessert l'ensemble du territoire de Saint-Jean-sur-Richelieu avec une connaissance approfondie des conditions locales.",
    problemLocal: "Dans les secteurs Iberville et Saint-Athanase, les entrées résidentielles montrent fréquemment des signes de saturation du sol en profondeur, se manifestant par des pavés qui basculent ou s'enfoncent différemment selon les saisons. Le secteur Saint-Luc, développé rapidement dans les années 80, présente des bases granulaires sous-dimensionnées qui se traduisent aujourd'hui par des ondulations et des irrégularités de surface sur de larges surfaces.",
  },
  {
    slug: "la-prairie",
    nameFr: "La Prairie",
    nameEn: "La Prairie",
    landmarkFr: "le Vieux-La Prairie",
    landmarkEn: "Old La Prairie",
    nearbyFr: "le fleuve Saint-Laurent",
    nearbyEn: "the St. Lawrence River",
    localNoteFr: "près du Vieux-La Prairie",
    localNoteEn: "near Old La Prairie",
    areasFr: ["Vieux-La Prairie", "La Citière", "La Clairière"],
    areasEn: ["Old La Prairie", "La Citière", "La Clairière"],
    intro: "À La Prairie, l'histoire des quartiers comme le Vieux-La Prairie se reflète dans l'état des aménagements extérieurs : des pavés posés il y a plusieurs décennies sur des bases qui ne répondent plus aux normes actuelles de résistance au gel. La Prairie est l'une des plus anciennes villes du Québec, et ses propriétés patrimoniales exigent une approche de réparation respectueuse de l'esthétique existante. Notre équipe adapte ses méthodes pour préserver le cachet des entrées tout en corrigeant les problèmes structurels en profondeur.",
    problemLocal: "Dans le Vieux-La Prairie et le secteur La Citière, les fondations granulaires des entrées en pavé uni ont subi plusieurs décennies de cycles gel-dégel sans réfection majeure, ce qui se traduit par des affaissements importants et des bordures complètement déstabilisées. Les terrains proches du fleuve à La Prairie présentent également une nappe phréatique variable qui contribue aux mouvements de sol et complique les corrections si elles ne sont pas réalisées avec les bons matériaux drainants.",
  },
  {
    slug: "candiac",
    nameFr: "Candiac",
    nameEn: "Candiac",
    landmarkFr: "le secteur Champlain",
    landmarkEn: "the Champlain sector",
    nearbyFr: "le boulevard Montcalm",
    nearbyEn: "Montcalm Boulevard",
    localNoteFr: "dans le secteur Champlain ou Saint-Laurent",
    localNoteEn: "in the Champlain or Saint-Laurent sector",
    areasFr: ["Secteur Champlain", "Secteur Saint-Laurent", "Secteur Montcalm"],
    areasEn: ["Champlain Sector", "Saint-Laurent Sector", "Montcalm Sector"],
    intro: "À Candiac, les secteurs résidentiels développés dans les années 70-80 comme Champlain et Saint-Laurent atteignent leur cycle de vie naturel pour les aménagements en pavé uni, avec des bases qui nécessitent une correction en profondeur. Le développement récent du secteur Montcalm crée un contraste visible avec les entrées vieillissantes des quartiers d'origine, motivant de nombreux propriétaires à rénover. Notre service de réparation de pavé uni à Candiac cible précisément les problèmes de fondation qui causent ces détériorations progressives.",
    problemLocal: "Dans le secteur Champlain à Candiac, les entrées présentent typiquement des affaissements aux points de transition entre les différentes zones de pavage, là où les bases se sont tassées différemment avec le temps. Le secteur Saint-Laurent montre des problèmes récurrents de pente insuffisante vers la rue, causant des accumulations d'eau qui accélèrent la dégradation des joints polymères et déstabilisent progressivement la surface.",
  },
  {
    slug: "saint-bruno-de-montarville",
    nameFr: "Saint-Bruno-de-Montarville",
    nameEn: "Saint-Bruno-de-Montarville",
    landmarkFr: "le mont Saint-Bruno",
    landmarkEn: "Mont Saint-Bruno",
    nearbyFr: "le Vieux-Village",
    nearbyEn: "the Old Village",
    localNoteFr: "près du Vieux-Village ou du mont Saint-Bruno",
    localNoteEn: "near the Old Village or Mont Saint-Bruno",
    areasFr: ["Vieux-Village", "Secteur des Fleurs", "Secteur de la Montagne"],
    areasEn: ["Old Village", "Fleurs Sector", "Mountain Sector"],
    intro: "À Saint-Bruno-de-Montarville, la topographie vallonnée autour du mont Saint-Bruno crée des défis de drainage particuliers pour les entrées en pavé uni, surtout dans le secteur de la Montagne où les pentes naturelles du terrain compliquent l'évacuation des eaux de fonte. Les arbres matures du Vieux-Village et du secteur des Fleurs ajoutent une pression racinaire constante sur les pavés et les bordures. Notre équipe maîtrise ces conditions spécifiques et intervient avec des solutions durables adaptées au terrain de Saint-Bruno.",
    problemLocal: "Dans le secteur des Fleurs à Saint-Bruno, les racines des arbres ornementaux plantés dans les années 80-90 ont progressivement soulevé de nombreuses entrées, créant des irrégularités de surface qui représentent à la fois un problème esthétique et un risque de sécurité. Le secteur de la Montagne présente des enjeux de drainage complexes : les pentes naturelles concentrent les eaux de ruissellement vers certaines entrées résidentielles, saturant les bases granulaires et accélérant les cycles de dégradation.",
  },
];

export const NAV_ITEMS = {
  fr: [
    { id: "home", label: "Accueil", path: "/fr" },
    {
      id: "repair",
      label: "Réparation",
      path: `/fr/services/${SERVICES.repair.slugFr}`,
    },
    {
      id: "installation",
      label: "Installation",
      path: `/fr/services/${SERVICES.installation.slugFr}`,
    },
    { id: "about", label: "À propos", path: "/fr/a-propos" },
    { id: "contact", label: "Contact", path: "/fr/contact" },
  ],
  en: [
    { id: "home", label: "Home", path: "/en" },
    {
      id: "repair",
      label: "Repair",
      path: `/en/services/${SERVICES.repair.slugEn}`,
    },
    {
      id: "installation",
      label: "Installation",
      path: `/en/services/${SERVICES.installation.slugEn}`,
    },
    { id: "about", label: "About", path: "/en/about" },
    { id: "contact", label: "Contact", path: "/en/contact" },
  ],
};

const baseRoutes = [
  { id: "home", fr: "/fr", en: "/en" },
  { id: "about", fr: "/fr/a-propos", en: "/en/about" },
  { id: "contact", fr: "/fr/contact", en: "/en/contact" },
  {
    id: "service-repair",
    fr: `/fr/services/${SERVICES.repair.slugFr}`,
    en: `/en/services/${SERVICES.repair.slugEn}`,
  },
  {
    id: "service-installation",
    fr: `/fr/services/${SERVICES.installation.slugFr}`,
    en: `/en/services/${SERVICES.installation.slugEn}`,
  },
];

const cityRoutes = CITY_DATA.flatMap((city) => [
  {
    id: `${city.slug}-repair`,
    fr: `/fr/villes/${city.slug}/${SERVICES.repair.slugFr}`,
    en: `/en/cities/${city.slug}/${SERVICES.repair.slugEn}`,
  },
  {
    id: `${city.slug}-installation`,
    fr: `/fr/villes/${city.slug}/${SERVICES.installation.slugFr}`,
    en: `/en/cities/${city.slug}/${SERVICES.installation.slugEn}`,
  },
]);

export const ROUTES = [...baseRoutes, ...cityRoutes];

export const getRouteByPath = (path) =>
  ROUTES.find((route) => route.fr === path || route.en === path);

export const getAlternateLanguagePath = (path, language) => {
  const route = getRouteByPath(path);
  if (!route) {
    return language === "fr" ? "/en" : "/fr";
  }
  return language === "fr" ? route.en : route.fr;
};

export const getNavItems = (language) => NAV_ITEMS[language] || NAV_ITEMS.fr;

export const getServicePath = (language, serviceKey) => {
  const service = SERVICES[serviceKey];
  if (!service) return language === "fr" ? "/fr" : "/en";
  return language === "fr"
    ? `/fr/services/${service.slugFr}`
    : `/en/services/${service.slugEn}`;
};

export const getCityServicePath = (language, citySlug, serviceKey) => {
  const service = SERVICES[serviceKey];
  if (!service) return language === "fr" ? "/fr" : "/en";
  return language === "fr"
    ? `/fr/villes/${citySlug}/${service.slugFr}`
    : `/en/cities/${citySlug}/${service.slugEn}`;
};

export const getSpecialServicePath = (language, serviceKey) => {
  const service = SPECIAL_SERVICES[serviceKey];
  if (!service) return language === "fr" ? "/fr" : "/en";
  return language === "fr"
    ? `/fr/services/${service.slugFr}`
    : `/en/services/${service.slugEn}`;
};

export const HOME_CONTENT = {
  fr: {
    metaTitle:
      "Réparation et installation de pavé uni Rive-Sud | Soumission gratuite",
    metaDescription:
      "Entreprise locale spécialisée en réparation et installation de pavé uni sur la Rive-Sud. Inspection gratuite, service haut de gamme et résultats durables.",
    hero: {
      eyebrow: "Spécialistes du pavé uni résidentiel",
      title: "Réparation et installation de pavé uni sur la Rive-Sud",
      subtitle:
        "Une équipe locale pour des entrées solides, des terrasses élégantes et un service clair du premier appel à la finition.",
      primaryCta: "Soumission gratuite",
      secondaryCta: "Voir nos services",
    },
    trust: [
      { value: "15+ ans", label: "Expertise locale" },
      { value: "100 %", label: "Résidentiel" },
      { value: "10 villes", label: "Rive-Sud" },
    ],
    process: [
      {
        title: "Diagnostic local",
        description:
          "Inspection de la base, du drainage et des pentes pour définir un plan précis.",
      },
      {
        title: "Travaux maîtrisés",
        description:
          "Nivellement au laser, compactage en couches et finitions soignées.",
      },
      {
        title: "Suivi durable",
        description:
          "Conseils d'entretien adaptés au gel-dégel pour prolonger la durée de vie.",
      },
    ],
    testimonial: {
      quote:
        "Notre entrée a retrouvé sa stabilité et son élégance. Le chantier était propre et l'équipe très professionnelle.",
      author: "Propriétaires de la Rive-Sud",
    },
    cta: {
      title: "Parlons de votre projet",
      text: "Recevez une estimation détaillée, un échéancier clair et des options adaptées à votre propriété.",
      button: "Planifier une visite",
    },
  },
  en: {
    metaTitle:
      "Paver repair and installation South Shore | Free estimate",
    metaDescription:
      "Local company specializing in paver repair and installation on Montréal's South Shore. Free inspection, premium service, and lasting results.",
    hero: {
      eyebrow: "Residential paver specialists",
      title: "Paver repair and installation on Montréal's South Shore",
      subtitle:
        "A local team delivering stable driveways, elegant patios, and clear communication from first call to final finish.",
      primaryCta: "Free estimate",
      secondaryCta: "Explore services",
    },
    trust: [
      { value: "15+ yrs", label: "Local expertise" },
      { value: "100%", label: "Residential focus" },
      { value: "10 cities", label: "South Shore" },
    ],
    process: [
      {
        title: "Local assessment",
        description:
          "We check the base, drainage, and grades to build a precise plan.",
      },
      {
        title: "Controlled work",
        description:
          "Laser leveling, layered compaction, and polished finishing details.",
      },
      {
        title: "Long-term care",
        description:
          "Maintenance guidance tailored to freeze-thaw cycles on the South Shore.",
      },
    ],
    testimonial: {
      quote:
        "Our driveway is level again and looks brand new. Professional crew and spotless finish.",
      author: "South Shore homeowners",
    },
    cta: {
      title: "Let's plan your project",
      text: "Get a detailed estimate, clear timeline, and options tailored to your property.",
      button: "Schedule a visit",
    },
  },
};

export const ABOUT_CONTENT = {
  fr: {
    title: "À propos de notre entreprise",
    subtitle:
      "Une équipe locale spécialisée dans le pavé uni résidentiel sur la Rive-Sud de Montréal.",
    paragraphs: [
      "Depuis plus de quinze ans, nous accompagnons les propriétaires de la Rive-Sud dans leurs projets de pavé uni. Nous croyons que chaque entrée et chaque terrasse doivent être aussi solides que belles. Notre approche combine un diagnostic précis, une préparation rigoureuse de la base et des finitions nettes pour résister au gel-dégel.",
      "Nous privilégions la transparence : explications claires, estimation détaillée et suivi du chantier. Notre équipe travaille avec des équipements professionnels et des matériaux adaptés au climat québécois afin d'offrir un résultat durable, sécuritaire et esthétique.",
      "Que vous soyez à Longueuil, Brossard, Saint-Hubert, Boucherville ou Saint-Jean-sur-Richelieu, vous obtenez un service local, fiable et haut de gamme.",
    ],
    valuesTitle: "Nos engagements",
    values: [
      "Respect des délais et du voisinage",
      "Travaux propres et sécuritaires",
      "Communication simple et honnête",
      "Finition soignée et durable",
    ],
    quote:
      "Nous traitons chaque projet comme si c'était le nôtre, avec précision et fierté.",
  },
  en: {
    title: "About our company",
    subtitle:
      "A local team focused on residential pavers across Montréal's South Shore.",
    paragraphs: [
      "For over fifteen years, we have helped South Shore homeowners create paver surfaces that are as strong as they are beautiful. Our work blends careful diagnostics, a disciplined base preparation, and crisp finishing details built to withstand freeze-thaw cycles.",
      "We value transparency: clear explanations, detailed estimates, and steady site follow-ups. Our crew uses professional equipment and materials suited to Québec's climate to deliver durable, safe, and elegant results.",
      "Whether you are in Longueuil, Brossard, Saint-Hubert, Boucherville, or Saint-Jean-sur-Richelieu, you receive a local, reliable, premium service.",
    ],
    valuesTitle: "Our commitments",
    values: [
      "Respectful timelines and tidy sites",
      "Clean and safe work zones",
      "Simple, honest communication",
      "Meticulous, long-lasting finishes",
    ],
    quote:
      "We treat every project as if it were our own, with pride and precision.",
  },
};

export const CONTACT_CONTENT = {
  fr: {
    title: "Contact",
    subtitle:
      "Obtenez une soumission gratuite pour votre projet de pavé uni sur la Rive-Sud.",
    formTitle: "Demande de soumission",
    infoTitle: "Coordonnées directes",
    mapTitle: "Zone de service",
    submit: "Envoyer la demande",
  },
  en: {
    title: "Contact",
    subtitle:
      "Request a free estimate for your paver project on Montréal's South Shore.",
    formTitle: "Estimate request",
    infoTitle: "Direct contact",
    mapTitle: "Service area",
    submit: "Send request",
  },
};

const buildFaqs = (language, cityName, serviceKey) => {
  const isFr = language === "fr";
  const service = SERVICES[serviceKey];
  const serviceLabel = isFr
    ? service.nameFr.toLowerCase()
    : service.nameEn.toLowerCase();
  if (isFr) {
    return [
      {
        question: `Quel est le meilleur moment pour la ${serviceLabel} à ${cityName} ?`,
        answer:
          "Le printemps et l'automne sont idéaux, mais nous pouvons intervenir dès que le sol est stable. Nous planifions selon la météo et les priorités locales pour offrir un résultat durable.",
      },
      {
        question: "Pouvez-vous réparer seulement une section ?",
        answer:
          "Oui. Nous isolons la zone problématique, corrigeons la base et réinstallons les pavés afin d'éviter une intervention complète inutile.",
      },
      {
        question: `Quel est le délai moyen pour les travaux à ${cityName} ?`,
        answer:
          "Un projet résidentiel standard se fait en une à trois journées selon la superficie et l'état de la base. Nous confirmons un échéancier précis après l'inspection.",
      },
      {
        question: "Faut-il remplacer tous les pavés ?",
        answer:
          "Souvent, les pavés peuvent être réutilisés. Nous évaluons l'usure et proposons le remplacement uniquement lorsque c'est nécessaire pour assurer l'uniformité.",
      },
      {
        question: `Offrez-vous une garantie à ${cityName} ?`,
        answer:
          "Oui. Nos travaux incluent une garantie sur la stabilité et la main-d'œuvre. Les détails sont clairement indiqués dans la soumission.",
      },
    ];
  }
  return [
    {
      question: `When is the best time for ${serviceLabel} in ${cityName}?`,
      answer:
        "Spring and fall are ideal, but we can work as soon as the ground is stable. We schedule around weather to deliver lasting results.",
    },
    {
      question: "Can you fix only a small section?",
      answer:
        "Yes. We isolate the affected area, correct the base, and reset the pavers to avoid unnecessary full replacement.",
    },
    {
      question: `How long do projects take in ${cityName}?`,
      answer:
        "Most residential projects take one to three days depending on size and base condition. We confirm the timeline after inspection.",
    },
    {
      question: "Do you need to replace all pavers?",
      answer:
        "Often we can reuse existing pavers. We recommend replacements only when needed to keep the surface uniform and durable.",
    },
    {
      question: `Do you offer a warranty in ${cityName}?`,
      answer:
        "Yes. Our work includes a workmanship and stability warranty, clearly outlined in the estimate.",
    },
  ];
};

export const buildCityServiceContent = (language, city, serviceKey) => {
  const isFr = language === "fr";
  const service = SERVICES[serviceKey];
  const cityName = city.nameFr || city.nameEn || city.name;
  const h1 = isFr
    ? `${service.nameFr} à ${cityName}`
    : `${service.nameEn} in ${cityName}`;
  const metaTitle = isFr
    ? `${service.nameFr} ${cityName} | Rive-Sud`
    : `${service.nameEn} ${cityName} | South Shore`;
  const metaDescription = isFr
    ? `${service.nameFr} locale à ${cityName}. Inspection gratuite, méthode professionnelle et résultats durables pour votre pavé uni résidentiel.`
    : `${service.nameEn} in ${cityName}. Free inspection, professional process, and lasting results for residential pavers.`;
  const intro = city.intro || (isFr
    ? `À ${cityName}, les entrées et terrasses en pavé uni subissent le gel-dégel, le sel et les cycles d'humidité qui finissent par déplacer les blocs. Notre service de ${service.nameFr.toLowerCase()} redonne une surface stable, propre et durable.`
    : `In ${cityName}, pave driveways and patios face freeze-thaw cycles, de-icing salt, and moisture that slowly shift the surface. Our ${service.nameEn.toLowerCase()} service restores a stable, clean, and lasting finish.`);
  const problems = city.problemLocal || (isFr
    ? `Les problèmes les plus fréquents à ${cityName} sont l'affaissement de zones localisées, les pavés qui se désalignent, les bordures qui s'ouvrent et les mauvaises pentes vers la fondation.`
    : `The most common issues in ${cityName} include sunken sections, shifted pavers, opened borders, and slopes that send water toward the house.`);
  const method = isFr
    ? `Notre méthode de travail professionnelle combine diagnostic, préparation et contrôle de la finition. Nous protégeons les aménagements, retirons les pavés concernés et corrigeons la base avec un nivellement au laser. Ensuite, nous compactons couche par couche, ajustons les pentes et remettons en place les pavés avec des coupes propres. Nous terminons par des joints polymères et un nettoyage complet du chantier. Chaque étape est documentée et expliquée afin que vous sachiez exactement ce qui a été fait à ${cityName}.`
    : `Our professional method blends diagnosis, preparation, and finish control. We protect landscaping, lift the affected pavers, and correct the base with laser leveling. We then compact layer by layer, adjust slopes, and reinstall the pavers with clean cuts. We finish with polymeric joints and a thorough cleanup. Every step is documented so you know exactly what was completed at your ${cityName} property.`;
  const why = isFr
    ? `Choisir notre entreprise, c'est miser sur une équipe locale qui connaît les sols de la Rive-Sud et les normes de performance recherchées par les propriétaires résidentiels. Nous offrons des conseils honnêtes, une communication claire et un respect rigoureux des délais. Nos équipements professionnels assurent un compactage uniforme et nos finitions sont soignées jusque dans les bordures et les transitions avec le gazon. Vous profitez d'un interlocuteur unique, d'une approche propre et d'un résultat haut de gamme.`
    : `Choosing our company means relying on a local team that understands South Shore soil conditions and the performance expectations of residential homeowners. We provide honest guidance, clear communication, and dependable timelines. Our professional equipment ensures even compaction, and our finishes are refined down to the borders and lawn transitions. You gain one point of contact, a clean process, and a premium result.`;
  const pricing = isFr
    ? `Le prix d'une ${service.nameFr.toLowerCase()} à ${cityName} dépend de la surface à traiter, de l'épaisseur de la base à corriger, du type de pavé et de l'accessibilité du chantier. Après une visite sur place, nous fournissons une estimation détaillée avec les options de matériaux, la durée prévue et les garanties offertes. Vous évitez les surprises et pouvez planifier vos travaux en toute confiance. La soumission est gratuite et sans engagement.`
    : `Pricing for ${service.nameEn.toLowerCase()} in ${cityName} depends on surface size, base corrections, paver selection, and site access. After an on-site visit, we provide a detailed estimate with material options, expected timelines, and warranties. You avoid surprises and can plan with confidence. The estimate is free and with no obligation.`;
  const areas = isFr
    ? `Nous desservons ${cityName} et les secteurs voisins comme ${(city.areasFr || city.secteurs || []).join(", ")}. Si vous êtes ${city.localNoteFr || "sur la Rive-Sud"}, notre équipe peut intervenir rapidement pour une inspection et un devis.`
    : `We serve ${cityName} and nearby sectors such as ${(city.areasEn || city.secteurs || []).join(", ")}. If you are ${city.localNoteEn || "on the South Shore"}, our team can respond quickly for an inspection and estimate.`;
  const faqs = buildFaqs(language, cityName, serviceKey);
  const relatedKey = serviceKey === "repair" ? "installation" : "repair";
  const relatedService = SERVICES[relatedKey];
  return {
    h1,
    metaTitle,
    metaDescription,
    intro,
    problems,
    method,
    why,
    pricing,
    areas,
    areasList: isFr ? city.areasFr : city.areasEn,
    faqs,
    ctaTitle: isFr
      ? "Obtenez votre soumission gratuite"
      : "Get your free estimate",
    ctaText: isFr
      ? `Parlez-nous de votre projet à ${cityName} et obtenez une recommandation claire pour votre ${service.nameFr.toLowerCase()}.`
      : `Tell us about your ${cityName} project and receive a clear recommendation for your ${service.nameEn.toLowerCase()}.`,
    ctaButton: isFr ? "Demander une soumission" : "Request an estimate",
    relatedService: {
      label: isFr ? relatedService.nameFr : relatedService.nameEn,
      path: getCityServicePath(language, city.slug, relatedKey),
    },
  };
};

export const buildServicePageContent = (language, serviceKey) => {
  const isFr = language === "fr";
  const service = SERVICES[serviceKey];
  const relatedKey = serviceKey === "repair" ? "installation" : "repair";
  const relatedService = SERVICES[relatedKey];
  return {
    h1: isFr
      ? `${service.nameFr} sur la Rive-Sud`
      : `${service.nameEn} on Montréal's South Shore`,
    metaTitle: isFr
      ? `${service.nameFr} Rive-Sud | Soumission gratuite`
      : `${service.nameEn} South Shore | Free estimate`,
    metaDescription: isFr
      ? `Service résidentiel de ${service.nameFr.toLowerCase()} sur la Rive-Sud. Base stable, drainage maîtrisé et finitions haut de gamme.`
      : `Residential ${service.nameEn.toLowerCase()} on the South Shore. Stable base, controlled drainage, and premium finishes.`,
    hero: {
      eyebrow: isFr
        ? "Service résidentiel haut de gamme"
        : "Premium residential service",
      subtitle: isFr
        ? service.descriptionFr
        : service.descriptionEn,
      cta: isFr ? service.ctaFr : service.ctaEn,
    },
    heroImage: service.heroImage,
    intro: isFr
      ? `Nous réalisons des projets de ${service.nameFr.toLowerCase()} partout sur la Rive-Sud pour les propriétaires qui veulent un pavé uni durable, bien nivelé et esthétique. Notre équipe locale suit une méthode rigoureuse : diagnostic, préparation de la base, pose précise et finitions soignées. Chaque projet est pensé pour résister au climat québécois et pour valoriser votre propriété.`
      : `We deliver ${service.nameEn.toLowerCase()} projects across the South Shore for homeowners who want durable, level, and elegant pavers. Our local team follows a disciplined method: diagnostics, base preparation, precise installation, and refined finishes. Each project is designed to withstand Québec's climate and elevate curb appeal.`,
    problemTitle: isFr ? "Problèmes que nous réglons" : "Problems we solve",
    problemText: isFr
      ? `Affaissements, pentes qui retiennent l'eau, joints dégradés ou pavés qui se déplacent : nous corrigeons les causes profondes pour stabiliser la surface et sécuriser les accès.`
      : `Sunken areas, pooling water, degraded joints, or shifting pavers: we correct the root causes to stabilize the surface and protect access points.`,
    solutionTitle: isFr ? "Notre solution" : "Our solution",
    solutionText: isFr
      ? `Nous remettons la base à niveau, compactons en couches et posons chaque pavé avec précision. Le drainage est ajusté pour éviter les infiltrations et prolonger la durée de vie.`
      : `We re-level the base, compact in layers, and install each paver precisely. Drainage is adjusted to prevent infiltration and extend lifespan.`,
    processTitle: isFr ? "Méthode de travail" : "Our process",
    processSteps: isFr
      ? [
          {
            title: "Inspection détaillée",
            description:
              "Analyse de la base, des pentes et des bordures pour établir un plan clair.",
          },
          {
            title: "Préparation rigoureuse",
            description:
              "Retrait des pavés, correction granulaire et compactage contrôlé.",
          },
          {
            title: "Finition premium",
            description:
              "Pose précise, joints polymères et nettoyage complet du chantier.",
          },
        ]
      : [
          {
            title: "Detailed inspection",
            description:
              "We assess the base, slopes, and borders to craft a clear plan.",
          },
          {
            title: "Rigorous preparation",
            description:
              "Pavers are lifted, the base corrected, and compaction controlled.",
          },
          {
            title: "Premium finish",
            description:
              "Precise laying, polymeric joints, and full site cleanup.",
          },
        ],
    galleryTitle: isFr ? "Réalisations" : "Work highlights",
    ctaTitle: isFr
      ? "Planifiez votre projet"
      : "Plan your project",
    ctaText: isFr
      ? "Recevez une estimation détaillée et des recommandations adaptées à votre maison."
      : "Receive a detailed estimate and recommendations tailored to your home.",
    ctaButton: isFr ? "Obtenir une estimation" : "Get an estimate",
    relatedService: {
      label: isFr ? relatedService.nameFr : relatedService.nameEn,
      path: getServicePath(language, relatedKey),
    },
  };
};

export const CITY_PAGES = [
  {
    slug: "longueuil",
    path: "/nettoyage-pave-uni-longueuil",
    city: {
      name: "Longueuil",
      slug: "longueuil",
      nameFr: "Longueuil",
      intro: "À Longueuil, le gel-dégel et les zones ombragées près du parc Michel-Chartrand accélèrent l'accumulation de mousse et de taches sur le pavé uni.",
      problemLocal: "Les entrées autour du Vieux-Longueuil et de la rue Saint-Charles sont particulièrement touchées par le noircissement et les joints fragilisés.",
      secteurs: ["Vieux-Longueuil", "Saint-Charles", "Greenfield Park"],
      faqLocal: "Intervenez-vous près du métro de Longueuil ? Oui, nous couvrons tout le secteur central et les quartiers résidentiels environnants."
    }
  },
  {
    slug: "brossard",
    path: "/nettoyage-pave-uni-brossard",
    city: {
      name: "Brossard",
      slug: "brossard",
      nameFr: "Brossard",
      intro: "À Brossard, les grandes entrées résidentielles autour du Quartier DIX30 et du boulevard Taschereau accumulent rapidement les taches de sel et les résidus hivernaux.",
      problemLocal: "Les propriétés des secteurs R et S présentent souvent des pavés noircis et des joints vidés après l'hiver.",
      secteurs: ["Quartier DIX30", "Secteur R", "Secteur S"],
      faqLocal: "Couvrez-vous tout Brossard ? Oui, incluant les secteurs C, R, S et les environs du boulevard Taschereau."
    }
  },
  {
    slug: "saint-hubert",
    path: "/nettoyage-pave-uni-saint-hubert",
    city: {
      name: "Saint-Hubert",
      slug: "saint-hubert",
      nameFr: "Saint-Hubert",
      intro: "À Saint-Hubert, les quartiers résidentiels autour du Parc de la Cité et du secteur Montarville voient leurs pavés s'encrasser rapidement avec les cycles gel-dégel.",
      problemLocal: "La mousse et les algues s'installent vite dans les zones ombragées près du Parc de la Cité.",
      secteurs: ["Parc de la Cité", "Montarville", "Vieux-Saint-Hubert"],
      faqLocal: "Intervenez-vous dans le secteur Kimber à Saint-Hubert ? Oui, nous couvrons l'ensemble de Saint-Hubert."
    }
  },
  {
    slug: "boucherville",
    path: "/nettoyage-pave-uni-boucherville",
    city: {
      name: "Boucherville",
      slug: "boucherville",
      nameFr: "Boucherville",
      intro: "À Boucherville, la proximité du fleuve et les secteurs boisés favorisent l'apparition rapide de mousse et d'algues sur le pavé uni résidentiel.",
      problemLocal: "Les entrées près du Vieux-Boucherville et de La Seigneurie accumulent humidité et résidus organiques plus vite qu'ailleurs.",
      secteurs: ["Vieux-Boucherville", "La Seigneurie", "Harmonie"],
      faqLocal: "Nettoyez-vous les pavés près des Îles-de-Boucherville ? Oui, nous intervenons dans tous les secteurs résidentiels de Boucherville."
    }
  },
  {
    slug: "saint-lambert",
    path: "/nettoyage-pave-uni-saint-lambert",
    city: {
      name: "Saint-Lambert",
      slug: "saint-lambert",
      nameFr: "Saint-Lambert",
      intro: "À Saint-Lambert, les rues patrimoniales du Vieux-Saint-Lambert et les propriétés riveraines de la promenade Riverside demandent un entretien régulier du pavé uni.",
      problemLocal: "Les taches de sel et la mousse s'accumulent rapidement sur les entrées ombragées du secteur Riverside et de Préville.",
      secteurs: ["Vieux-Saint-Lambert", "Riverside", "Préville"],
      faqLocal: "Intervenez-vous près de la promenade Riverside à Saint-Lambert ? Oui, c'est l'un de nos secteurs les plus actifs."
    }
  },
  {
    slug: "chambly",
    path: "/nettoyage-pave-uni-chambly",
    city: {
      name: "Chambly",
      slug: "chambly",
      nameFr: "Chambly",
      intro: "À Chambly, les propriétés autour du Fort Chambly et du bassin accumulent rapidement mousse et résidus en raison de l'humidité ambiante.",
      problemLocal: "Les entrées du Vieux-Chambly et des secteurs riverains sont particulièrement sujettes aux taches et aux joints fragilisés.",
      secteurs: ["Vieux-Chambly", "Bassin de Chambly", "Hertel"],
      faqLocal: "Nettoyez-vous les pavés autour du Fort Chambly ? Oui, nous couvrons tout Chambly et les environs de Carignan."
    }
  },
  {
    slug: "saint-jean-sur-richelieu",
    path: "/nettoyage-pave-uni-saint-jean-sur-richelieu",
    city: {
      name: "Saint-Jean-sur-Richelieu",
      slug: "saint-jean-sur-richelieu",
      nameFr: "Saint-Jean-sur-Richelieu",
      intro: "À Saint-Jean-sur-Richelieu, la proximité du canal de Chambly et du Richelieu crée une humidité persistante qui favorise la croissance de mousse sur le pavé uni.",
      problemLocal: "Les quartiers Iberville et Saint-Luc voient fréquemment leurs pavés noircir et leurs joints se vider après les cycles hivernaux.",
      secteurs: ["Vieux-Saint-Jean", "Iberville", "Saint-Luc"],
      faqLocal: "Intervenez-vous à Iberville et Saint-Luc ? Oui, nous couvrons l'ensemble de Saint-Jean-sur-Richelieu."
    }
  },
  // LA PRAIRIE - NETTOYAGE
  {
    slug: "la-prairie",
    path: "/nettoyage-pave-uni-la-prairie",
    serviceKey: "cleaning",
    city: {
      name: "La Prairie",
      slug: "la-prairie",
      nameFr: "La Prairie",
      intro: "À La Prairie, les quartiers historiques comme le Vieux-La Prairie et La Citière accumulent rapidement mousse et résidus en raison de fondations vieillissantes et des cycles gel-dégel.",
      problemLocal: "Les entrées du Vieux-La Prairie sont particulièrement touchées par le déchaussement des pavés et les joints érodés après des décennies de cycles hivernaux.",
      secteurs: ["Vieux-La Prairie", "La Citière", "La Clairière"],
      faqLocal: "Intervenez-vous dans le Vieux-La Prairie ? Oui, c'est l'un de nos secteurs prioritaires sur la Rive-Sud."
    }
  },
  // LA PRAIRIE - RÉPARATION
  {
    slug: "la-prairie-reparation",
    path: "/reparation-pave-uni-la-prairie",
    serviceKey: "repair",
    city: {
      name: "La Prairie",
      slug: "la-prairie",
      nameFr: "La Prairie",
      intro: "À La Prairie, les fondations de gravier des quartiers La Citière et La Clairière arrivent souvent en fin de vie, causant affaissements et ornières sur les entrées résidentielles.",
      problemLocal: "Le Vieux-La Prairie présente des pavés déchaussés par le gel-dégel et des zones d'accumulation d'eau dues à des pentes mal orientées.",
      secteurs: ["Vieux-La Prairie", "La Citière", "La Clairière"],
      faqLocal: "Réparez-vous les affaissements causés par une fondation usée à La Prairie ? Oui, c'est notre spécialité - correction de base et remise à niveau."
    }
  },
  // LA PRAIRIE - INSTALLATION
  {
    slug: "la-prairie-installation",
    path: "/installation-pave-uni-la-prairie",
    serviceKey: "installation",
    city: {
      name: "La Prairie",
      slug: "la-prairie",
      nameFr: "La Prairie",
      intro: "À La Prairie, de nombreux propriétaires de La Citière et La Clairière choisissent de remplacer complètement leurs vieilles entrées pour repartir sur une base neuve, stable et durable.",
      problemLocal: "Les entrées d'origine des années 70-80 dans La Citière ont souvent des fondations trop minces pour être simplement réparées - une installation complète est souvent la meilleure solution.",
      secteurs: ["Vieux-La Prairie", "La Citière", "La Clairière"],
      faqLocal: "Faites-vous des installations complètes à La Prairie ? Oui, de la préparation de la base jusqu'à la finition finale."
    }
  },
  // LA PRAIRIE - SCELLANT
  {
    slug: "la-prairie-scellant",
    path: "/scellant-pave-uni-la-prairie",
    serviceKey: "sealing",
    city: {
      name: "La Prairie",
      slug: "la-prairie",
      nameFr: "La Prairie",
      intro: "À La Prairie, l'application d'un scellant protecteur après nettoyage ou réparation prolonge considérablement la durée de vie des pavés dans des quartiers comme La Clairière et le Vieux-La Prairie.",
      problemLocal: "Les pavés des années 80-90 à La Prairie ont souvent perdu leur protection naturelle - un scellant moderne redonne couleur et résistance au sel et aux UV.",
      secteurs: ["Vieux-La Prairie", "La Citière", "La Clairière"],
      faqLocal: "Appliquez-vous le scellant après nettoyage à La Prairie ? Oui, c'est une combinaison que nous recommandons fortement pour prolonger la durée de vie."
    }
  },
  // CANDIAC - NETTOYAGE
  {
    slug: "candiac",
    path: "/nettoyage-pave-uni-candiac",
    serviceKey: "cleaning",
    city: {
      name: "Candiac",
      slug: "candiac",
      nameFr: "Candiac",
      intro: "À Candiac, les secteurs Champlain et Saint-Laurent accumulent rapidement mousse et mauvaises herbes dans les joints en raison de l'âge des aménagements et des cycles hivernaux répétés.",
      problemLocal: "Le secteur Champlain, l'un des premiers développés à Candiac, présente des joints de sable polymère érodés et des dalles affaissées typiques des quartiers d'origine.",
      secteurs: ["Secteur Champlain", "Secteur Saint-Laurent", "Secteur Montcalm"],
      faqLocal: "Intervenez-vous dans le secteur Champlain à Candiac ? Oui, nous couvrons l'ensemble de Candiac incluant les quartiers d'origine."
    }
  },
  // CANDIAC - RÉPARATION
  {
    slug: "candiac-reparation",
    path: "/reparation-pave-uni-candiac",
    serviceKey: "repair",
    city: {
      name: "Candiac",
      slug: "candiac",
      nameFr: "Candiac",
      intro: "À Candiac, les quartiers Saint-Laurent et Montcalm voient leurs entrées atteindre leur cycle de vie naturel - affaissements, bordures ouvertes et joints dégradés sont les signes typiques.",
      problemLocal: "Le secteur Saint-Laurent a déjà été ciblé par la ville pour des travaux de réfection - les entrées résidentielles adjacentes présentent souvent les mêmes problèmes de base.",
      secteurs: ["Secteur Champlain", "Secteur Saint-Laurent", "Secteur Montcalm"],
      faqLocal: "Réparez-vous les affaissements dans le secteur Montcalm à Candiac ? Oui, nous intervenons dans tous les secteurs résidentiels de Candiac."
    }
  },
  // CANDIAC - INSTALLATION
  {
    slug: "candiac-installation",
    path: "/installation-pave-uni-candiac",
    serviceKey: "installation",
    city: {
      name: "Candiac",
      slug: "candiac",
      nameFr: "Candiac",
      intro: "À Candiac, la transformation du secteur Montcalm inspire de nombreux propriétaires à moderniser leurs entrées avec une installation complète en pavé uni neuf.",
      problemLocal: "Les contrastes entre les nouvelles constructions du secteur Montcalm et les vieux pavages adjacents rendent les nouvelles installations particulièrement populaires pour uniformiser l'apparence du quartier.",
      secteurs: ["Secteur Champlain", "Secteur Saint-Laurent", "Secteur Montcalm"],
      faqLocal: "Faites-vous des nouvelles installations à Candiac ? Oui, conception complète, base compactée et finition haut de gamme."
    }
  },
  // CANDIAC - SCELLANT
  {
    slug: "candiac-scellant",
    path: "/scellant-pave-uni-candiac",
    serviceKey: "sealing",
    city: {
      name: "Candiac",
      slug: "candiac",
      nameFr: "Candiac",
      intro: "À Candiac, un scellant protecteur appliqué sur les pavés des secteurs Champlain et Saint-Laurent protège contre le sel de déglaçage et prolonge l'apparence des aménagements.",
      problemLocal: "Les pavés du secteur Champlain, parmi les plus anciens de Candiac, bénéficient grandement d'un scellant pour ralentir leur dégradation et faciliter l'entretien.",
      secteurs: ["Secteur Champlain", "Secteur Saint-Laurent", "Secteur Montcalm"],
      faqLocal: "Appliquez-vous le scellant dans le secteur Saint-Laurent à Candiac ? Oui, nous couvrons tous les secteurs résidentiels de Candiac."
    }
  },
  // SAINT-BRUNO-DE-MONTARVILLE - NETTOYAGE
  {
    slug: "saint-bruno-de-montarville",
    path: "/nettoyage-pave-uni-saint-bruno-de-montarville",
    serviceKey: "cleaning",
    city: {
      name: "Saint-Bruno-de-Montarville",
      slug: "saint-bruno-de-montarville",
      nameFr: "Saint-Bruno-de-Montarville",
      intro: "À Saint-Bruno-de-Montarville, la proximité du mont Saint-Bruno et les arbres matures du secteur des Fleurs créent des conditions humides qui favorisent la croissance de mousse sur le pavé uni.",
      problemLocal: "Le secteur des Fleurs présente souvent des joints lessivés et des pavés des années 80-90 noircis par les résidus organiques des arbres environnants.",
      secteurs: ["Vieux-Village", "Secteur des Fleurs", "Secteur de la Montagne"],
      faqLocal: "Nettoyez-vous les pavés près du mont Saint-Bruno ? Oui, nous couvrons l'ensemble de Saint-Bruno-de-Montarville."
    }
  },
  // SAINT-BRUNO - RÉPARATION
  {
    slug: "saint-bruno-de-montarville-reparation",
    path: "/reparation-pave-uni-saint-bruno-de-montarville",
    serviceKey: "repair",
    city: {
      name: "Saint-Bruno-de-Montarville",
      slug: "saint-bruno-de-montarville",
      nameFr: "Saint-Bruno-de-Montarville",
      intro: "À Saint-Bruno-de-Montarville, les racines d'arbres matures du Vieux-Village soulèvent régulièrement les pavés, et les pentes du secteur de la Montagne créent des enjeux de drainage importants.",
      problemLocal: "Les entrées autour de l'église et du lac du Village sont particulièrement touchées par le soulèvement des pavés causé par les racines et les fondations vieillissantes.",
      secteurs: ["Vieux-Village", "Secteur des Fleurs", "Secteur de la Montagne"],
      faqLocal: "Réparez-vous les pavés soulevés par les racines d'arbres à Saint-Bruno ? Oui, c'est une intervention fréquente que nous maîtrisons bien."
    }
  },
  // SAINT-BRUNO - INSTALLATION
  {
    slug: "saint-bruno-de-montarville-installation",
    path: "/installation-pave-uni-saint-bruno-de-montarville",
    serviceKey: "installation",
    city: {
      name: "Saint-Bruno-de-Montarville",
      slug: "saint-bruno-de-montarville",
      nameFr: "Saint-Bruno-de-Montarville",
      intro: "À Saint-Bruno-de-Montarville, les propriétés du secteur de la Montagne et du Vieux-Village optent souvent pour une installation complète pour corriger définitivement les problèmes de drainage et de stabilité.",
      problemLocal: "Les pentes du secteur de la Montagne exigent une installation avec drainage intégré pour éviter que l'eau ne déstabilise murets et escaliers en pavé.",
      secteurs: ["Vieux-Village", "Secteur des Fleurs", "Secteur de la Montagne"],
      faqLocal: "Faites-vous des installations avec gestion du drainage à Saint-Bruno ? Oui, c'est essentiel pour les propriétés en pente dans ce secteur."
    }
  },
  // SAINT-BRUNO - SCELLANT
  {
    slug: "saint-bruno-de-montarville-scellant",
    path: "/scellant-pave-uni-saint-bruno-de-montarville",
    serviceKey: "sealing",
    city: {
      name: "Saint-Bruno-de-Montarville",
      slug: "saint-bruno-de-montarville",
      nameFr: "Saint-Bruno-de-Montarville",
      intro: "À Saint-Bruno-de-Montarville, un scellant protecteur appliqué sur les pavés du secteur des Fleurs et du Vieux-Village protège contre l'humidité, les résidus organiques et le sel hivernal.",
      problemLocal: "Les pavés des années 80-90 du secteur des Fleurs ont perdu leur protection naturelle - un scellant moderne redonne couleur et résistance aux conditions humides près de la montagne.",
      secteurs: ["Vieux-Village", "Secteur des Fleurs", "Secteur de la Montagne"],
      faqLocal: "Appliquez-vous le scellant près du mont Saint-Bruno ? Oui, nous recommandons fortement le scellant dans ce secteur pour contrer l'humidité ambiante."
    }
  },
];
